/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountItemGroupModifierSchema } from "./calculateDiscountItemGroupModifierSchema.ts";

export const calculateDiscountItemGroupUnionModifierSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(calculateDiscountItemGroupModifierSchema),
});
